import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, InputWithLabel, RadioGroup, Text } from '@reveni-io/reveni-ui'

import DatePicker from '@/common/components/DatePicker/DatePicker'

import { extendTargetValues } from './constants'
import { getModeOptions, getTargetOptions } from './helpers'
import * as Styles from './styles'

const getExtendTarget = config => {
  if (config.extend_returns && config.extend_exchanges) return extendTargetValues.both
  if (config.extend_exchanges) return extendTargetValues.exchanges
  return extendTargetValues.returns
}

const getExtendMode = config => {
  if (config.extend_by_days !== null && config.extend_by_days !== undefined) return 'by_days'
  return 'until_date'
}

const ExtendReturnWindowConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasExtendError = errors.some(e => e.type === 'actionExtendConfigIncomplete')
  const translatedTargetOptions = getTargetOptions(t)
  const translatedModeOptions = getModeOptions(t)

  const extendTarget = getExtendTarget(config)
  const extendMode = getExtendMode(config)

  const handleChangeTarget = value => {
    onChangeConfig({
      extend_returns: value === extendTargetValues.returns || value === extendTargetValues.both,
      extend_exchanges: value === extendTargetValues.exchanges || value === extendTargetValues.both,
    })
  }

  const handleChangeMode = value => {
    if (value === 'by_days') {
      onChangeConfig({ extend_until_date: null, extend_by_days: config.extend_by_days ?? '' })
    } else {
      onChangeConfig({ extend_by_days: null, extend_until_date: config.extend_until_date || null })
    }
  }

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Opciones')}</Text>
      <ComboBox
        label={t('Ampliar')}
        menuItems={translatedTargetOptions}
        handleChange={e => handleChangeTarget(e.target.value)}
        value={extendTarget}
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
      />
      <RadioGroup
        name="extend-mode"
        options={translatedModeOptions}
        value={extendMode}
        onChange={e => handleChangeMode(e.target.value)}
      />
      <Styles.InputWrapper>
        {extendMode === 'by_days' ? (
          <InputWithLabel
            label={t('Días')}
            value={config.extend_by_days || ''}
            onChange={e => onChangeConfig({ extend_by_days: e.target.value })}
            type="number"
            disabled={disabled}
            backgroundColor={theme.colors.background.primary}
            error={hasExtendError && !config.extend_by_days}
            helperText={hasExtendError && !config.extend_by_days ? t('Este campo es obligatorio') : undefined}
          />
        ) : (
          <DatePicker
            value={config.extend_until_date || null}
            onChange={value => onChangeConfig({ extend_until_date: value })}
            label={t('Fecha')}
            disabled={disabled}
            backgroundColor={theme.colors.background.primary}
            clearable
          />
        )}
      </Styles.InputWrapper>
    </Styles.Container>
  )
}

export default ExtendReturnWindowConfig
